import { memo } from "react";

import { PostObserver } from "@/components/app/post/post-observer";
import type { PostType } from "@/contexts/feed-context";
import { useFeedInternalContext } from "@/contexts/feed-context";
import { PostContextProvider } from "@/contexts/post-context";
import { cn } from "@/utils/lib";

import { FeedPostDetails } from "./feed-post-details";

const INITIAL_RENDERED_COUNT = 15;

export const FeedPostItem = memo(
  ({ post, index }: { post: PostType; index: number }) => {
    const {
      onUserBlock,
      updatePostByHash,
      setPinnedPost,
      setPinnedPostAssociationId,
      pinnedPostAssociationId,
      checkIfPostIsPinned,
    } = useFeedInternalContext();

    if (!post || !post.postHash) return null;

    return (
      <PostContextProvider
        {...{
          post,
          setPinnedPost,
          setPinnedPostAssociationId,
          pinnedPostAssociationId,
          onUserBlock,
          updatePostByHash,
          isPinned: checkIfPostIsPinned(post.postHash),
        }}
      >
        <PostObserver
          key={post.postHash}
          initialIsIntersecting={index < INITIAL_RENDERED_COUNT}
        >
          <div
            className={cn(
              `
                unforce-radius h-full cursor-pointer border-border
                first:border-b
                hover:bg-accent
              `,
            )}
          >
            <FeedPostDetails className="xl:p-6" clickable />
          </div>
        </PostObserver>
      </PostContextProvider>
    );
  },
);

FeedPostItem.displayName = "FeedPostItem";
